import { render, staticRenderFns } from "./OverunderPage.vue?vue&type=template&id=0c4c94b0&scoped=true&"
import script from "./OverunderPage.vue?vue&type=script&lang=js&"
export * from "./OverunderPage.vue?vue&type=script&lang=js&"
import style0 from "./OverunderPage.vue?vue&type=style&index=0&id=0c4c94b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c94b0",
  null
  
)

export default component.exports